import { forwardRef } from "react";
import { Disclosure as RACDisclosure } from "react-aria-components";

import { cn } from "../../utils/cn";
import { useAccordionContext } from "./context";

import type { DisclosureProps as RACDisclosureProps, Key as RACKey } from "react-aria-components";

export interface AccordionProps extends Omit<RACDisclosureProps, "className" | "children" | "id"> {
  /** Stable key required when inside AccordionGroup. */
  id: RACKey;
  className?: string | ((s: { isDisabled: boolean; isExpanded: boolean }) => string);
  children?: React.ReactNode;
}

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  ({ id, className, children, ...props }, ref) => {
    const { slots, classNames } = useAccordionContext();
    return (
      <RACDisclosure
        id={id}
        ref={ref}
        {...props}
        className={s =>
          cn(
            slots.item(),
            classNames?.item,
            typeof className === "function" ? className(s) : className
          )
        }
      >
        {children}
      </RACDisclosure>
    );
  }
);
Accordion.displayName = "Accordion";
